export default {
  connection: null,
  rooms: {},
  messages: {},
  notifications: 0,
  participants: {},
  users: {}
}
